import { Image } from '@tiptap/extension-image';
import { Link } from '@tiptap/extension-link';
import { Placeholder } from '@tiptap/extension-placeholder';
import { Content, useEditor } from '@tiptap/react';
import { StarterKit } from '@tiptap/starter-kit';
import { useTranslation } from 'react-i18next';

interface UseEditorConfigProps {
  fileContent: Content;
  onUpdate?: () => void;
}

export function useEditorConfig({ fileContent, onUpdate }: UseEditorConfigProps) {
  const { t } = useTranslation();

  return useEditor({
    extensions: [
      StarterKit.configure({
        paragraph: {
          HTMLAttributes: { class: 'block-paragraph' }
        },
        bulletList: {
          HTMLAttributes: { class: 'block-bullet-list' }
        },
        listItem: {
          HTMLAttributes: { class: 'block-list-item' }
        },
        history: {
          depth: 100,
          newGroupDelay: 500
        }
      }),
      Image.configure({
        allowBase64: true,
        HTMLAttributes: {
          style: 'margin: 1rem auto; display: block; max-width: 100%;',
          draggable: 'true',
          class: 'selectable-image'
        }
      }),
      Placeholder.configure({
        placeholder: t('SMART_EDITOR.NEW_BLOCK_PLACEHOLDER'),
        emptyEditorClass: 'is-editor-empty',
        emptyNodeClass: 'is-empty',
        showOnlyCurrent: true,
        showOnlyWhenEditable: true
      }),
      Link.configure({
        HTMLAttributes: {
          target: '_blank',
          rel: 'noopener noreferrer',
          class: 'notion-link'
        }
      })
    ],
    content: fileContent,
    onUpdate: () => {
      if (onUpdate) onUpdate();
    }
  });
}
